
import React from 'react';
import { RefreshCw, Sparkles } from 'lucide-react';

interface Step2BenchmarkProps {
    humanTranslation: string;
    setHumanTranslation: (text: string) => void;
    onBack: () => void;
    onStartTranslation: () => void;
    isTranslating: boolean;
}

const Step2Benchmark: React.FC<Step2BenchmarkProps> = ({
    humanTranslation,
    setHumanTranslation,
    onBack,
    onStartTranslation,
    isTranslating
}) => {
    return (
        <div className="flex flex-col h-full w-full max-w-[90rem] mx-auto animate-in fade-in slide-in-from-bottom-8 duration-700">
            <div className="mb-6 text-center space-y-2 shrink-0">
                <h2 className="text-3xl font-black text-slate-800 tracking-tight">Benchmark Data</h2>
                <p className="text-slate-500 font-medium text-sm">Loaded from text en.md. Edit if needed for the Audit step.</p>
            </div>
            <div className="flex-1 relative group min-h-[60vh] flex flex-col">
                <div className="absolute -inset-1 bg-gradient-to-r from-emerald-200 to-teal-200 rounded-[2.5rem] opacity-40 blur group-focus-within:opacity-60 transition duration-500"></div>
                <div className="relative flex-1 bg-white rounded-[2rem] border border-slate-200 shadow-lg flex flex-col overflow-hidden">
                    <div className="px-8 py-4 border-b border-slate-100 bg-slate-50 shrink-0"><span className="text-xs font-bold text-emerald-600 uppercase tracking-widest">HUMAN_REFERENCE_EN.TXT</span></div>
                    <div className="flex-1 relative">
                        <textarea
                            value={humanTranslation}
                            onChange={(e) => setHumanTranslation(e.target.value)}
                            className="absolute inset-0 w-full h-full bg-transparent text-base text-slate-700 p-8 outline-none resize-none leading-relaxed font-sans custom-scrollbar"
                            spellCheck={false}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-8 flex justify-between items-center px-12 shrink-0">
                <button onClick={onBack} className="text-slate-500 hover:text-slate-700 font-bold uppercase tracking-widest">Back</button>
                <button onClick={onStartTranslation} disabled={isTranslating} className="px-12 py-5 bg-indigo-600 text-white hover:bg-indigo-500 rounded-2xl font-black text-sm uppercase tracking-widest flex items-center gap-3 shadow-lg">
                    {isTranslating ? <RefreshCw className="animate-spin" /> : <Sparkles />}
                    {isTranslating ? 'Processing...' : 'Run Translation'}
                </button>
            </div>
        </div>
    );
};

export default Step2Benchmark;
